// @flow

import _ from 'lodash';

import type { DocumentDictionaryItem } from 'calc-common';
import type { KnownRestIdentityDocTypeEnum } from 'known-rest-identity-docs';

const findDocumentName = (
	dictionary: Array<DocumentDictionaryItem>,
	documentType: KnownRestIdentityDocTypeEnum): ?string => {

	const document = _.find(dictionary, { ID: documentType });
	return document && document.Name;
};

export const documentRepr = (dictionary: Array<DocumentDictionaryItem>) => {
	return {
		default: (documentType: KnownRestIdentityDocTypeEnum) =>
			findDocumentName(dictionary, documentType),
		lowerFirst: (documentType: KnownRestIdentityDocTypeEnum) => {
			const name = findDocumentName(dictionary, documentType);
			return name && _.lowerFirst(name);
		},
	};
};